<div class="input-group mb-3 mt-3" style="width: 305px;">
    <span class="input-group-text pointer" (click)="search()">{{'搜尋' | translate}}</span>
    <input type="text" class="form-control shadow-none" placeholder="{{'關鍵字' | translate}}" [(ngModel)]="searchText">
</div>